import {
  CompareUserSimilarityQuery,
  GetUserViewQuery,
} from "@/graphql/graphql";
import { Circle, Event } from "@/models";
import { IDX_DB_VALUE_KEYS, indexedDbStorage } from "@/utils/indexDBStorage";
import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

export interface IVisitOtherProfileStore {
  user?: GetUserViewQuery["getUserView"];
  circles?: Circle[];
  events?: Event[];
  activity?: CompareUserSimilarityQuery["compareUserSimilarity"];
  cgs?: {
    [key: string]: {
      value: number;
      lastFetch: Date;
    };
  };
  profilePicture?: {
    [key: string]: {
      path: string;
      url: string;
    };
  };
}

interface mutateState {
  setState: (payload: IVisitOtherProfileStore) => void;
}

const useVisitOtherProfileStore = create<
  IVisitOtherProfileStore & mutateState
>()(
  persist(
    (set) => ({
      setState: (payload) =>
        set((state) => ({
          ...state,
          ...payload, // Only merge the properties in payload
        })),
    }),
    {
      name: IDX_DB_VALUE_KEYS.profileUserCGPS,
      storage: indexedDbStorage as unknown as PersistStorage<unknown>,
      partialize: (state) => ({
        cgs: state?.cgs,
        profilePicture: state?.profilePicture,
      }),
    }
  )
);

export default useVisitOtherProfileStore;
